import React, { useState } from 'react';
import { Row, Col } from "react-bootstrap"
import { useTranslation } from "react-i18next";
import { DefaultButton, PrimaryButton } from '@fluentui/react/lib/Button';
import { Panel, PanelType } from '@fluentui/react/lib/Panel';
import { useBoolean } from '@fluentui/react-hooks';
import { Dialog, DialogFooter, DialogType } from '@fluentui/react/lib/Dialog';
import { __ConsolidationLeters, __MessageTypes, __Deactivate } from '../../../common/Dictionaries';
import { __OBJECT_STRUCTURE_GetBoarScope } from '../../../common/ObjectStructures/sKPI';
import { _global_buttonStyles, __OBJECT_STRUCTURE_GetList } from '../../../common/ObjectStructures/Trasnversal';
import MessageBox from '../../../components/Common/Message/MessageBox';
import PropTypes from 'prop-types';
import CTextBox from '../../../components/Common/CTextBox';

import { isNullUndefinedOrEmpty, showMessage } from '../../../common/Helpers';
import { Dropdown } from '@fluentui/react';
import { useDispatch } from 'react-redux';
import { __Consolidation } from '../../../common/Dictionaries';
import { __ComponentTypes } from '../../../common/Dictionaries';

const SidePanelModifyContainer = (props) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    
    const { 
        inputParam_IsPanelOpen = null,
        inputParam_SetterIsPanelOpen = null,
        inputParam_Container = null,
        inputParam_ContainerComponentType = null,
        inputParam_SetterContainerData = null
    } = props;

    const [isDialogVisible, { setTrue: showDialog, setFalse: hideDialog }] = useBoolean(false);
    const [objContainerTitle, setObjContainerTitle] = useState(inputParam_Container.title);
    const [objContainerComponentType, setObjContainerComponeneType] = useState(
        inputParam_ContainerComponentType === null ? { id: 0, name: "" } : inputParam_ContainerComponentType);

    const [messageConfig, setMessageConfig] = useState({
        message : null,
        messageType : "",
        showMessage : false,
    });

    const [isValidForm, setIsValidForm] = useState({
        title: true,
        type: true,
    });
    

    const validateForm = () => {
        let isValid = true;

        isValidForm.title = !isNullUndefinedOrEmpty(objContainerTitle);
        isValidForm.type = objContainerComponentType !== null ? (objContainerComponentType.id !== 0) : false;

        isValid = isValidForm.title && isValidForm.type;

        setIsValidForm(isValidForm)

        return isValid
    }

    const onHideDialog = (ev) => {
        ev.preventDefault();
        inputParam_SetterIsPanelOpen(true);
        hideDialog();
    };

    const onDismissPanel = () => {
        inputParam_SetterIsPanelOpen(false);
        showMessage(setMessageConfig, false, null, null)

        setIsValidForm({
            title: true,
            type: true,
        });
        setObjContainerTitle("");
        setObjContainerComponeneType(null)
    };

    const onChangeComponentType = (ev, item) => {
        setIsValidForm(prevState => ({
            ...prevState,
            type: true
        }));
        
        setObjContainerComponeneType({
            id: item.key,
            minHeigthPoints: item.minHeigthPoints,
            minWidthPoints: item.minWidthPoints,
            name: item.title
        });
    };

    const onHideDialogAndPanel = () => {
        onDismissPanel();
        hideDialog();
    };
    
    const onClosePanel = () => {
        onDismissPanel();
    };

    const onSaveContainer = () => {
        if (validateForm()) {
            inputParam_SetterContainerData(inputParam_Container, objContainerComponentType, objContainerTitle);
            onDismissPanel();
        }
        else {
            showMessage(setMessageConfig, true, __MessageTypes.WARNING, t('data-lang-msg-requireddatanotset'))
        }
    }

    const setterObjContainerTitle = (controlValue) => {
        
        if (!isNullUndefinedOrEmpty(controlValue)) {
            setIsValidForm(prevState => ({
                ...prevState,
                title: true
            }));
        }
        else {
            setIsValidForm(prevState => ({
                ...prevState,
                title: false
            }));
        }

        setObjContainerTitle(controlValue)
    }

    const onRenderFooterContent = () => {
        return  <Row>
                    <Col xl={12} className="message-verybottom-panel-medium">
                        <MessageBox
                            inputParam_Message={ messageConfig.message }
                            inputParam_Display={ messageConfig.showMessage }
                            inputParam_MessageType={ messageConfig.messageType }
                            inputParam_SetterMessage={ setMessageConfig }
                        />
                    </Col>
                    <Col xl={12}>
                        <PrimaryButton onClick={ () => onSaveContainer() } styles={_global_buttonStyles}>{ t('data-lang-btn-save') }</PrimaryButton>
                        <DefaultButton onClick={ () =>  onClosePanel() }>{ t('data-lang-btn-cancel') }</DefaultButton>
                    </Col>
                </Row>
    }

    return (
        <div>
            <Panel
                isOpen={ inputParam_IsPanelOpen }
                isLightDismiss={ true }
                onLightDismissClick={ showDialog }
                onDismiss={ onDismissPanel }
                headerText={ t('data-lang-boxname-modifycontainer') }
                closeButtonAriaLabel={ t('data-lang-btn-close') }
                isFooterAtBottom={ true }
                onRenderFooterContent={ onRenderFooterContent }
                customWidth={ PanelType.medium }
                type={ PanelType.medium }
            >
                <Row className="pt-5">
                    <Col>
                        <CTextBox
                            labelText={t('data-lang-lbl-title2')}
                            controlValue={objContainerTitle}
                            setterControlValue={setterObjContainerTitle}
                            isInValid={!isValidForm.title}
                        />
                    </Col>
                </Row>
                <Row className="pt-5">
                    <Col>
                        <div className="pb-1"><b>{t('data-lang-lbl-componenttype')}</b></div>
                        <Dropdown
                            placeholder={t('data-lang-placeholder-selectoption')}
                            options={ __ComponentTypes.map(({ key, text, minHeigthPoints, minWidthPoints }) => {return {key: key, minWidthPoints: minWidthPoints, minHeigthPoints: minHeigthPoints, title: t(text), text: t(text) }}) }
                            selectedKey={objContainerComponentType !== null ? objContainerComponentType.id : 0}
                            styles={ {title: { height: "27px" }, errorMessage: { fontSize: "14px" }} }
                            className="pt-2"
                            errorMessage={objContainerComponentType !== null ? (!isValidForm.type ? t('data-lang-msg-required') : undefined) : (!isValidForm.type ? t('data-lang-msg-required') : undefined) }
                            required={objContainerComponentType !== null ? (!isValidForm.type ? true : false) : (!isValidForm.type ? true : false)}
                            onChange={ onChangeComponentType }
                        />
                    </Col>
                </Row>
                <Dialog
                    hidden={!isDialogVisible}
                    onDismiss={onHideDialog}
                    dialogContentProps={{
                        type: DialogType.normal,
                        title: t('data-lang-msg-close-panel'),
                    }}
                    modalProps={{
                        isBlocking: true,
                        styles: { main: { maxWidth: 450 } },
                    }}
                    >
                    <DialogFooter>
                        <PrimaryButton onClick={onHideDialogAndPanel} text={t('data-lang-lbl-yes')} />
                        <DefaultButton onClick={onHideDialog} text={t('data-lang-lbl-no')} />
                    </DialogFooter>
                </Dialog>
            </Panel>
        </div>
    );
};

SidePanelModifyContainer.propTypes = {
    inputParam_IsPanelOpen: PropTypes.bool.isRequired,
    inputParam_SetterIsPanelOpen: PropTypes.func.isRequired,
};

export default SidePanelModifyContainer;